import { render, staticRenderFns } from "./channelCell.vue?vue&type=template&id=096162f0&scoped=true"
import script from "./channelCell.vue?vue&type=script&lang=js"
export * from "./channelCell.vue?vue&type=script&lang=js"
import style0 from "./channelCell.vue?vue&type=style&index=0&id=096162f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096162f0",
  null
  
)

export default component.exports